import React from 'react';
import { useTranslation } from './translationContext';

const messageId = {
  infoMessage: 'tablefilter.infoMessage',
  search: 'tablefilter.search',
  searchFields: 'tablefilter.searchFields.subheading'
};

const TableFilterErrorMessage = () => {
  const { t } = useTranslation();
  return (
    <div>
      <p>{t('tablefilter.addMoreFields')}</p>
    </div>
  );
};

const TableFilterTitle = ({ fieldLength }) => {
  const { t } = useTranslation();
  return (
    <>
      <div>
        <h2 className="form-group">{t(messageId.search)}</h2>
      </div>
      <div>
        <div className="row ">
          <div className="col-xs-12 col-sm-12">
            <p className="form-group">{t(messageId.infoMessage)}</p>
            <p className="search-field">{t(messageId.searchFields)}</p>
          </div>
        </div>
      </div>

      <div className="row">{fieldLength === 0 && <TableFilterErrorMessage />}</div>
    </>
  );
};

export default TableFilterTitle;
